import fetch from "utils/fetch";

export const fetchFigures = ({ params, ...rest }) => {
  return fetch({
    url: 'figures',
    method: "GET",
    params,
    ...rest
  });
};

export const fetchFiguresAll = ({ params, ...rest }) => {
  return fetch({
    url: `figures/all`,
    method: "GET",
    params,
    ...rest
  });
};


export const fetchFigure = ({ id, params, ...rest }) => {
  return fetch({
    url: `figures/${id}`,
    method: "GET",
    params,
    ...rest
  });
};

export const updateFigure = ({ id, data, ...rest }) => {
  return fetch({
    url: `figures/${id}`,
    method: "PUT",
    data,
    ...rest
  });
};

export const createFigure = ({ data, ...rest }) => {
  return fetch({
    url: `figures`,
    method: "POST",
    data,
    ...rest
  });
};
